<template>
  <div class="stock-alert">
    <p class="stock-alert__text">
      {{ $t('stock_alert.product_form_msg') }}
    </p>
    <div class="productpage__flexrow">
      <a
        id="stock-alert-modal-button"
        class="btn btn--large btn--block modal-velociraptor-trigger"
        rel="nofollow"
        @click.prevent="openModal"
      >
        {{ $t('stock_alert.product_form_btn') }}
      </a>
      <transition name="fade">
        <wishlist-widget />
      </transition>
    </div>
    <link itemprop="availability" href="https://schema.org/OutOfStock" />

    <modal
      data-modal="stock-alert"
      :content-class="'modal-velociraptor--stockalert'"
      :open="isModalOpen"
      :show-footer="false"
      @close="closeModal"
    >
      <template v-slot:title>{{ $t('stock_alert.modal_title') }}</template>

      <stock-alert-form
        :product-id="productId"
        :material="material"
        :case-device-id="caseDeviceId"
        @submitted="closeModal"
      />
    </modal>
  </div>
</template>

<script>
import Modal from '~/components/Modal'
import StockAlertForm from '~/components/product/form/StockAlertForm'
import WishlistWidget from '~/components/product/wishlist-widget/WishlistWidget'

export default {
  name: 'StockAlert',
  components: {
    Modal,
    StockAlertForm,
    WishlistWidget,
  },
  props: {
    productId: {
      type: Number,
      required: true,
    },
    caseDeviceId: {
      type: [Number, String],
      default: '',
    },
    material: {
      type: String,
      default: '',
    },
    startOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isModalOpen: false,
    }
  },
  created() {
    if (this.startOpen) {
      this.isModalOpen = true
    }
  },
  methods: {
    openModal() {
      this.isModalOpen = true
    },
    closeModal() {
      this.isModalOpen = false
    },
  },
}
</script>
